module.exports = __webpack_public_path__ + "static/media/icon-5.9382642f.png";